module.exports = __webpack_public_path__ + "static/media/abrir-modal.5a277e34.svg";